import React, { useState, useEffect, useRef } from 'react'
import {  Checkbox , Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';

const DuplicateHierarchy = ({ propdata, loadData , location  , parentSelected = true  , setNestedData }) => {
	const [input, setInput] = useState("");
	const [expand, setExpand] = useState(false);
	const handleExpandOpen = () => { setExpand(!expand); };
	const [selectedData , setSelectedData] = useState({})
	const [editView , setEditView] = useState('normal');

	useEffect(() => {
		if (propdata?.id) {
			setExpand(true);
		}
	}, [propdata]);

	const handleCheckboxChange = (checked) => {
		propdata.selected = checked;

		if (!checked) {
			const unselectChildren = (node) => {
				if (node.locations) {
					node.locations.forEach(loc => {
						loc.selected = false;
						unselectChildren(loc);
					});
				}

				if (node.items) {
					node.items.forEach(item => {
						item.selected = false;
					});
				}
			};
			unselectChildren(propdata);
		}

		setSelectedData((prev) => ({ ...prev, [propdata.id]: checked }));
		setNestedData(prev => ({ ...prev })); 
	};

	useEffect(() => {
		if (propdata?.location_description) {
			setInput(propdata?.location_description);
		}
	}, [propdata]);


	return (
		<>
			<div>
				<div className='inventory-container'>
					<div className='header-container'>
						<div style={{ paddingLeft: 10, width: '100%' , marginBottom: (propdata?.item?.item_type === null) ? '-22px' : '' }}>
								<div style={{ height: propdata?.id == location?.id ? editView == 'edit-view' ? '30px' : '22px' : '46px'}}>
									<div >
											<div onClick={handleExpandOpen}>
													{(propdata?.locations?.length > 0 || propdata?.items?.length > 0) && (location?.id != propdata?.id) ? (
															expand ? (
																<img
																		src="/images/down-arrow.svg"
																		style={{
																			marginLeft: '-40px',
																			marginBottom: '-25px',
																			cursor: 'pointer',
																		}}
																/>
																) : (location?.id != propdata?.id) &&(
																<img
																		src="/images/up-arrow.svg"
																		style={{
																			marginLeft: '-40px',
																			marginBottom: '-25px',
																			cursor: 'pointer',
																		}}
																/>
															)
													) : (
															<> 
															{(propdata?.type === 'location' || propdata?.type === 'location_item') && (location?.id != propdata?.id)? (
																	<img
																	src="/images/up-arrow.svg"
																	style={{
																			marginLeft: '-40px',
																			marginBottom: '-25px',
																			cursor: 'pointer',
																	}}
																	/>
															) : (
																	<div style={{ marginBottom: '24px' }}></div>
															)}
															</>
													)}
											</div>

											<div style={{display:'flex' , alignItems:'center' , justifyContent:'space-between'}}>
												<div style={{display:'flex' , alignItems:'center' , marginTop:'-16px'}} className = {propdata?.id === location?.id && 'style-checklist-items'}>
													<div>
														{((propdata?.type == null && propdata?.id === location) || (propdata?.type == 'location')) && (
															<img src="/images/location-blue-new.svg" width='20px' height='20px' style={{ marginTop: "-6px" }} />
														)}
														{propdata?.type == 'location_item' && (
																<img src="/images/location-item.svg" style={{ marginTop: "-6px" }} />
														)}
														{propdata?.item?.item_type === null && (
																<img src="/images/location-blue.svg" style={{ marginTop: "-6px" , marginLeft:'-3px' }} />
														)}
													</div>
														<div style={{marginLeft:'8px'}}>
															{propdata?.id === location?.id ? 
																'' : 
																<Checkbox
																	checked={propdata.selected || false}
																	onChange={(e) => handleCheckboxChange(e.target.checked)}
																	disabled={!parentSelected && propdata?.id !== location}
																/>
															}
														</div>

														{propdata?.id === location?.id ?
															(
																editView == 'edit-view' ? 
																(
																	<div>
																		<input
																				type="text"
																				value={input}
																				placeholder="Enter location name"
																				onChange={(e) => {
																					const newValue = e.target.value;
																					setInput(newValue);
																					if (propdata) {
																						propdata.location_description = newValue;
																					}
																					setNestedData(prev => ({ ...prev }));
																				}}
																				className="input-black-placeholder"
																				style={{
																					width: '100%',
																					padding: '6px 12px',
																					fontSize: '12px',
																					borderRadius: '5px',
																					border: '1px solid #ddd',
																					color:'#000000'
																				}}
																			/>
																	</div>
																)
																: 
																(<div>
																	{propdata?.location_description}
																</div>)
															)
															: 
															(
																<div>
																	{(propdata?.item?.item_description && propdata?.item_quantity ? `${propdata?.item?.item_description}`: propdata?.location_description)}
																</div>
															)
														}
														
														{propdata?.id === location?.id &&
															(
																editView == 'normal' ? 
																	<div>
																		<EditIcon sx={{ color: '#555555' , height:'20px' , width:'20px' , marginLeft:'10px', cursor:'pointer'}}
																		onClick={() => setEditView('edit-view')}
																		/>
																	</div>
																:
																<div>
																	<VisibilityIcon sx={{ color: '#555555' , height:'20px' , width:'20px' , marginLeft:'10px', cursor:'pointer'}}
																		onClick={() => setEditView('normal')}
																		/>
																	</div>
															)
														}															
												</div>
											</div>
									</div>
								</div>
						</div>
					</div>

					<div style={{ display: expand ? "block" : "none", paddingLeft: '20px', marginLeft: '20px',  borderLeft: '1px solid #5362EB'}}>
						{[...(propdata?.locations || []), ...(propdata?.items || [])].map((nesData) => (
							<DuplicateHierarchy
								key={nesData.id}
								propdata={nesData}
								loadData={loadData}
								location={location}
								parentSelected={propdata.selected}
								setNestedData={setNestedData} 
							/>
						))}
					</div>
				</div>
			</div>
		</>
	)
}

export default DuplicateHierarchy;